import { render } from "./ProfileDetailComponent.vue?vue&type=template&id=db7641e4&scoped=true"
import script from "./ProfileDetailComponent.vue?vue&type=script&lang=js"
export * from "./ProfileDetailComponent.vue?vue&type=script&lang=js"

import "./ProfileDetailComponent.vue?vue&type=style&index=0&id=db7641e4&scoped=true&lang=css"

import exportComponent from "/home/runner/work/acp-portal-frontend/acp-portal-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db7641e4"]])

export default __exports__